/**
 * Shared Framer Motion variants used across Primordeia pages.
 *
 * Why a module? Inline object props (`initial={{ opacity: 0 }}`) create a fresh
 * object on every render, which breaks `React.memo` and triggers unnecessary
 * Framer Motion re-evaluation. Exporting stable references fixes both.
 */

// ─── Fade + Y-slide (the workhorse for cards and headings) ────────────────
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

export const fadeInUpDelayed = (delay) => ({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { delay },
});

export const fadeInLeft = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};

// ─── Height-collapse transitions (used for accordion-style detail panels) ──
export const expandHeight = {
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
};

// ─── Button interaction primitives ────────────────────────────────────────
export const tapHover = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 },
};

export const tapHoverStrong = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
};

export const tapHoverIcon = {
  whileHover: { scale: 1.1 },
  whileTap: { scale: 0.9 },
};

// ─── Pulse loops (used for highlight dots / "next" indicators) ────────────
export const pulseRing = {
  animate: { scale: [1, 1.15, 1], opacity: [0.6, 1, 0.6] },
  transition: { repeat: Infinity, duration: 1.5 },
};

// ─── Modal entrance (lotus paywall etc.) ──────────────────────────────────
export const popIn = {
  initial: { scale: 0.5, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.92, opacity: 0 },
  transition: { type: "spring", damping: 18, stiffness: 220 },
};
